// *** Forgot Password Component ****
import React, { useEffect, useState } from "react";
import "../../assets/css/forgotpswd.css";
import PasswordReset from "../../commonComponents/PasswordReset";

const SendPopup = () => {
    return (
        <div>
            <PasswordReset
            image="verify"
            title="Email Sent Successfully"
            content= " We've sent a password reset link to your email address. Please check your inbox  to reset your password."/>
        </div>
    );
};
export default SendPopup;

